import React, { useState } from 'react';

const Tooltip = ({ text, children, className="" }) => {
    const [visible, setVisible] = useState(false);

    const showTooltip = () => setVisible(true);
    const hideTooltip = () => setVisible(false);

    return (
        <div className="relative inline-block" onMouseEnter={showTooltip} onMouseLeave={hideTooltip}>
            {children}
            {visible && (
                <div className={`pointer-events-none absolute bottom-full left-1/2 z-40 mb-2 -translate-x-1/2 whitespace-nowrap rounded-lg bg-[#211b4f] px-2.5 py-1.5 text-xs font-medium text-white shadow-lg ${className}`}>
                    {text}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
